__turbopack_context__.v({
  "hero": "hero-module-scss-module__lA0Loa__hero",
  "heroCursorBlink": "hero-module-scss-module__lA0Loa__heroCursorBlink",
  "heroFloatParticle0": "hero-module-scss-module__lA0Loa__heroFloatParticle0",
  "heroFloatParticle1": "hero-module-scss-module__lA0Loa__heroFloatParticle1",
  "heroFloatParticle2": "hero-module-scss-module__lA0Loa__heroFloatParticle2",
  "heroFloatParticle3": "hero-module-scss-module__lA0Loa__heroFloatParticle3",
  "heroFloatParticle4": "hero-module-scss-module__lA0Loa__heroFloatParticle4",
  "heroFloatParticle5": "hero-module-scss-module__lA0Loa__heroFloatParticle5",
  "heroFloatParticle6": "hero-module-scss-module__lA0Loa__heroFloatParticle6",
  "heroFloatParticle7": "hero-module-scss-module__lA0Loa__heroFloatParticle7",
  "heroGlitch": "hero-module-scss-module__lA0Loa__heroGlitch",
  "heroLogoGlassGlow": "hero-module-scss-module__lA0Loa__heroLogoGlassGlow",
  "heroScanLine": "hero-module-scss-module__lA0Loa__heroScanLine",
  "hero__btnIcon": "hero-module-scss-module__lA0Loa__hero__btnIcon",
  "hero__btnPrimary": "hero-module-scss-module__lA0Loa__hero__btnPrimary",
  "hero__btnPrimaryInner": "hero-module-scss-module__lA0Loa__hero__btnPrimaryInner",
  "hero__btnSecondary": "hero-module-scss-module__lA0Loa__hero__btnSecondary",
  "hero__container": "hero-module-scss-module__lA0Loa__hero__container",
  "hero__content": "hero-module-scss-module__lA0Loa__hero__content",
  "hero__ctas": "hero-module-scss-module__lA0Loa__hero__ctas",
  "hero__cursor": "hero-module-scss-module__lA0Loa__hero__cursor",
  "hero__description": "hero-module-scss-module__lA0Loa__hero__description",
  "hero__floatParticle": "hero-module-scss-module__lA0Loa__hero__floatParticle",
  "hero__floatParticleIcon": "hero-module-scss-module__lA0Loa__hero__floatParticleIcon",
  "hero__greeting": "hero-module-scss-module__lA0Loa__hero__greeting",
  "hero__grid": "hero-module-scss-module__lA0Loa__hero__grid",
  "hero__heading": "hero-module-scss-module__lA0Loa__hero__heading",
  "hero__logoArea": "hero-module-scss-module__lA0Loa__hero__logoArea",
  "hero__logoBox": "hero-module-scss-module__lA0Loa__hero__logoBox",
  "hero__logoFloat": "hero-module-scss-module__lA0Loa__hero__logoFloat",
  "hero__logoGlass": "hero-module-scss-module__lA0Loa__hero__logoGlass",
  "hero__logoGlow": "hero-module-scss-module__lA0Loa__hero__logoGlow",
  "hero__logoImg": "hero-module-scss-module__lA0Loa__hero__logoImg",
  "hero__logoInner": "hero-module-scss-module__lA0Loa__hero__logoInner",
  "hero__name": "hero-module-scss-module__lA0Loa__hero__name",
  "hero__nameGlitch": "hero-module-scss-module__lA0Loa__hero__nameGlitch",
  "hero__pulse": "hero-module-scss-module__lA0Loa__hero__pulse",
  "hero__pulseInner": "hero-module-scss-module__lA0Loa__hero__pulseInner",
  "hero__ring": "hero-module-scss-module__lA0Loa__hero__ring",
  "hero__ring2": "hero-module-scss-module__lA0Loa__hero__ring2",
  "hero__ringDot": "hero-module-scss-module__lA0Loa__hero__ringDot",
  "hero__ringDot2": "hero-module-scss-module__lA0Loa__hero__ringDot2",
  "hero__scanLine": "hero-module-scss-module__lA0Loa__hero__scanLine",
  "hero__skillTag": "hero-module-scss-module__lA0Loa__hero__skillTag",
  "hero__skills": "hero-module-scss-module__lA0Loa__hero__skills",
  "hero__statCard": "hero-module-scss-module__lA0Loa__hero__statCard",
  "hero__statCardHover": "hero-module-scss-module__lA0Loa__hero__statCardHover",
  "hero__statContent": "hero-module-scss-module__lA0Loa__hero__statContent",
  "hero__statLabel": "hero-module-scss-module__lA0Loa__hero__statLabel",
  "hero__statValue": "hero-module-scss-module__lA0Loa__hero__statValue",
  "hero__stats": "hero-module-scss-module__lA0Loa__hero__stats",
  "hero__title": "hero-module-scss-module__lA0Loa__hero__title",
  "hero__titleGlow": "hero-module-scss-module__lA0Loa__hero__titleGlow",
  "hero__titleWrap": "hero-module-scss-module__lA0Loa__hero__titleWrap",
  "hero__welcomeBadge": "hero-module-scss-module__lA0Loa__hero__welcomeBadge",
  "hero__welcomeIcon": "hero-module-scss-module__lA0Loa__hero__welcomeIcon",
});
